export default (zone) => {
  if (zone) {
    return zone;
  } else {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
};
